export const LENDER_ANALYTIC_EVENTS = {
  LENDER_CREATED: "LENDER_CREATED",
  LENDER_UPDATED: "LENDER_UPDATED",
  LENDER_DELETED: "LENDER_DELETED",
};

